import "./styles.scss";
import PropTypes from "prop-types";

const DOCOnlineSpinner = ({ text }) => {
  return (
    <div className="card inboard p-4 doconline-spinner">
      <p>{text}</p>
    </div>
  );
};

export default DOCOnlineSpinner;

DOCOnlineSpinner.PropType = {
  text: PropTypes.string
};
